import ClearFileExceedModal from './ClearFileExceedModal';

export default ClearFileExceedModal;
